export default __webpack_public_path__ + "static/media/Ntorq125Racing_Frente.659e056d.webp";